import { motion } from "framer-motion";
import RoastLevel from "~/components/RoastLevel.jsx";
import ActiveMarker from "~/components/ActiveMarker.jsx";

const labels = ["bright-light", "light", "medium", "full-medium", "dark", "beyond-dark"];

const positions = labels.map((label, index) => {
  return {
    label,
    x: `${(100 / (labels.length * 2)) * (2 * index + 1)}%`,
  };
});

console.log("positions", positions);

const Sidebar = ({ collections, activeCollectionHandler, activeCollection }) => {
  // console.log("collections", collections);
  // console.log("activeCollection", activeCollection);

  return (
    <>
      {collections.length > 0 && (
        <div
          className={`w-[48px] md:w-1/3 px-0 py-0 md:px-8 md:py-0 space-y-2 grid shadow-xl relative`}
          style={{
            background:
              "linear-gradient(to bottom, #E5C17C 0%, #F1AA1E 24%, #D48232 41%, #BC4700 58%, #8C88A3 76%, #003B4D 100%)",
          }}>
          {collections.map((collection) => (
            <RoastLevel
              key={collection.collectionHandle}
              roastLevel={collection.collectionHandle}
              activeCollectionHandler={activeCollectionHandler}
              activeCollection={activeCollection}
            />
          ))}

          <motion.div
            className="absolute right-0 md:right-8 top-0"
            animate={{
              top: positions.find(
                (position) => position.label === activeCollection.collectionHandle
              ).x,
            }}
            transition={{ type: "spring", stiffness: 50, damping: 20 }}>
            <ActiveMarker />
          </motion.div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
